export default "__VITE_ASSET__d3b8c4f8__"